import Section from './Section'
import Card from './Card'
import SectionHead from './SectionHead'

// What real people say.
//
// ⚠️ BUILT, AND DELIBERATELY EMPTY (founder 2026-10-02). The component and its
// styling ship now so the section is ready the day we have quotes; the data file
// (src/content/quotes.js) is empty until there are CONSENTED quotes from real
// pilot users. With no quotes this renders NOTHING — not a placeholder, not a
// lorem card, not a stock face.
//
// Two rules behind that:
//   · "No empty states, no dead ends" (CLAUDE.md). A section with nothing in it
//     does not render.
//   · A testimonial is a claim (spec §8). An invented one is a false claim, and a
//     stock photograph beside real words implies a person who does not exist.
//
// To switch it on: add entries to src/content/quotes.js. Each needs the person’s
// own words, their first name, their role and their town, and a record that they
// agreed to it being published.

export default function Proof({ quotes, eyebrow = 'In their words', title }) {
  if (!quotes?.length) return null

  return (
    <Section ground="canvas">
      <SectionHead eyebrow="{eyebrow}" title={<>{title}</>} />
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {quotes.map((q) => (
          <Card as="figure" key={q.name + q.town}>
            <blockquote className="text-[19px] leading-relaxed text-ink">{q.quote}</blockquote>
            <figcaption className="mt-5 text-[15px] text-ink-muted">
              <span className="font-semibold text-ink">{q.name}</span>
              {' · '}{q.role}{' · '}{q.town}
            </figcaption>
          </Card>
        ))}
      </div>
    </Section>
  )
}
